import React from "react";
import { useWarehouseContext } from "./WarehouseProvider";
import { WeightCapture } from "./components/WeightCapture";
import packagingWeightIcon from "./images/packaging-weight-icon.png";

const TITLE = "Weigh Empty Cardboard Box";

export const PackagingWeightCapture = () => {
  const { packagingWeight, setPackagingWeight } = useWarehouseContext();

  return (
    <WeightCapture
      title={TITLE}
      instruction={
        <div className="flex flex-col gap-10">
          <div>
            Place the empty cardboard box inside the control container with no
            other items
          </div>
          <div className="bg-[#060E23] border border-[#282F44] rounded-xl px-4 py-3 mb-3 text-center">
            <span className="font-mono text-lg leading-tight uppercase text-white">
              ⚖️ WEIGH: CONTROL CONTAINER + EMPTY CARDBOARD BOX
            </span>
          </div>
        </div>
      }
      icon={packagingWeightIcon}
      iconAlt="Packaging Weight"
      value={packagingWeight}
      onChange={setPackagingWeight}
      showRejectButton={false}
    />
  );
};

PackagingWeightCapture.title = TITLE;
